var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new_course_render", attrs: { id: "new_course_render" } },
    [
      _c("div", { staticClass: "currentValueName" }, [
        _vm.currentValue.name || _vm.currentValue.tagName
          ? _c(
              "span",
              {
                staticStyle: {
                  "justify-content": "center",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _vm.currentValue.tagName === "共享资源"
                  ? _c(
                      "div",
                      { staticClass: "item-table" },
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading,
                                expression: "loading"
                              }
                            ],
                            ref: "multipleTable",
                            staticClass: "table",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.tableData,
                              stripe: "",
                              "tooltip-effect": "dark"
                            },
                            on: {
                              "selection-change": _vm.handleSelectionChange
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                type: "index",
                                label: "序号",
                                width: "60"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          _vm._s(
                                            (_vm.pageTotal.page - 1) *
                                              _vm.pageTotal.pageSize +
                                              scope.$index +
                                              1
                                          )
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2411960320
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "文件名称",
                                "show-overflow-tooltip": "",
                                align: "left"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "typeName",
                                label: "类型",
                                width: "150",
                                align: "left"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "sizeStr",
                                label: "大小",
                                width: "150",
                                align: "left"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              scope.row.type == 5 ||
                                                scope.row.type == 6
                                                ? ""
                                                : scope.row.sizeStr
                                            ) +
                                            "\n                  "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                798863595
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "address",
                                label: "操作",
                                width: "150",
                                align: "left"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.table_previewBtn(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("预览")]
                                        ),
                                        _vm._v(" "),
                                        scope.row.type != 5 &&
                                        scope.row.type != 6 &&
                                        scope.row.downloadFlag == 1
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  type: "text",
                                                  size: "mini"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.table_downloadBtn(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("下载")]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                870220192
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "empty_material",
                                attrs: { slot: "empty" },
                                slot: "empty"
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/image/sources/table_no_data.png"),
                                    alt: "加载失败"
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", [_vm._v("暂无数据")])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("Pagination", {
                          attrs: {
                            page: _vm.pageTotal.page,
                            limit: _vm.pageTotal.pageSize,
                            total: _vm.pageTotal.total,
                            layout: "total, sizes, prev, pager, next, jumper",
                            small: true
                          },
                          on: { pagination: _vm.handleCurrentChange }
                        })
                      ],
                      1
                    )
                  : _vm.currentValue.showFlag && _vm.showTopCurrentValueName
                  ? _c("span", {
                      staticClass:
                        "new_course_render_name editorShowArea ql-editor",
                      staticStyle: { "padding-right": "10px" },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.currentValue.tagName || _vm.currentValue.name
                        )
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isShow && _vm.currentValue.taskType == 1 && _vm.userType > 1
                  ? [
                      _vm.currentValue.isFinish == 1
                        ? _c("img", {
                            staticClass: "is_finish",
                            attrs: { src: _vm.isFinish }
                          })
                        : _c("img", {
                            staticClass: "is_finish",
                            attrs: { src: _vm.unFinish }
                          })
                    ]
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "currentValueBtn" }, [
          _vm.userType <= 1 &&
          _vm.currentValue.taskType == 1 &&
          _vm.currentValue.resourceType === 3 &&
          _vm.courseType == "3" &&
            (_vm.type == 1 || _vm.type == 2 || _vm.type == 3)
            ? _c(
                "span",
                [
                  _vm._v("\n           允许查看答案\n           "),
                  _c("el-switch", {
                    attrs: {
                      "active-value": 1,
                      "inactive-value": 0,
                      "active-color": "#1890FF",
                      "inactive-color": "#D2D2D7"
                    },
                    on: { change: _vm.selectViewAnswers },
                    model: {
                      value: _vm.currentValue.show,
                      callback: function($$v) {
                        _vm.$set(_vm.currentValue, "show", $$v)
                      },
                      expression: "currentValue.show"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isIT &&
          _vm.currentValue.taskType == 1 &&
          _vm.currentValue.resourceType === 3 &&
          _vm.courseType == "3" &&
            (_vm.type == 1 || _vm.type == 2 || _vm.type == 3)
            ? _c(
                "span",
                { staticClass: "currentValueBtn2" },
                [
                  _vm.userType != 2 ||
                  (_vm.currentValue.show && _vm.currentValue.isFinish == 1)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.openReferenceAnswer }
                        },
                        [_vm._v("查看参考答案")]
                      )
                    : _c(
                        "el-button",
                        {
                          attrs: {
                            title: _vm.currentValue.show
                              ? "请作答后再查看答案"
                              : "老师未允许查看参考答案",
                            disabled: "",
                            type: "primary",
                            size: "mini"
                          }
                        },
                        [_vm._v("查看参考答案")]
                      ),
                  _vm._v(" "),
                  _vm.userType != 2 ||
                  (_vm.currentValue.show && _vm.currentValue.isFinish == 1)
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.openRatingDetails }
                        },
                        [_vm._v("评分详情")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.currentValue.szrtType == 1 ||
      _vm.currentValue.szrtType == 2 ||
      _vm.currentValue.szrtType == 8
        ? _c(
            "div",
            {
              staticClass: "showFileStyle",
              style: _vm.projectType === "native" ? "background: #000000" : ""
            },
            [
              _vm.currentValue.szrtType == 1 || _vm.currentValue.szrtType == 2
                ? [
                    _vm.projectType === "native"
                      ? _c("zl_pdf", {
                          attrs: {
                            src:
                              _vm.currentValue.convertUrl ||
                              _vm.currentValue.newAttaUrl
                          }
                        })
                      : _c("iframe", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: {
                            id: "pptIframe",
                            src: _vm.iframeUrl,
                            frameborder: "0"
                          }
                        })
                  ]
                : [
                    _vm.currentValue.typeSuffix === "xlsx" ||
                    _vm.currentValue.typeSuffix === "xls"
                      ? _c("iframe", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: { src: _vm.iframeUrl, frameborder: "0" }
                        })
                      : [
                          _vm.isZip
                            ? _c("iframe", {
                                attrs: {
                                  width: "100%",
                                  height: "100%",
                                  src: _vm.currentValue.newAttaUrl,
                                  frameborder: "0"
                                }
                              })
                            : _c("div", [
                                _vm.isShow && _vm.currentValue.downloadFlag == 1
                                  ? _c("p", [
                                      _vm._v(
                                        "请点击“下载”，下载 “" +
                                          _vm._s(_vm.currentValue.name) +
                                          "” 到本地。"
                                      )
                                    ])
                                  : _c("p", [_vm._v("该压缩文件无法预览")])
                              ])
                        ]
                  ]
            ],
            2
          )
        : _vm.currentValue.szrtType === 4
        ? _c("div", { staticClass: "contentItem" }, [
            _c(
              "video",
              {
                ref: "newCourseVideo",
                staticClass: "video-js status_1_content_resouce",
                attrs: {
                  controls: "",
                  preload: "auto",
                  controlslist: "nodownload",
                  "data-setup": "{'example_option':true}"
                },
                on: { play: _vm.videoPlay, ended: _vm.endVideo }
              },
              [
                _c("source", {
                  staticClass: "video",
                  attrs: {
                    src: _vm.currentValue.newAttaUrl,
                    type: "video/mp4"
                  },
                  on: { click: _vm.videoPlay }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "vjs-no-js" }, [_vm._v("不支持播放")])
              ]
            )
          ])
        : _vm.currentValue.szrtType === 6
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.renderLoading,
                  expression: "renderLoading"
                }
              ],
              staticClass: "type6style",
              staticStyle: { height: "calc(100% - 70px)", overflow: "auto" },
              attrs: { id: "type6style" }
            },
            [
              _c(
                "div",
                _vm._l(_vm.currentValue.imageText, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "scroll" + item.sort,
                      refInFor: true,
                      staticClass: "type6Item",
                      class: { jyxClass: _vm.courseId == 3156 },
                      style: {
                        "text-align": item.styleOption
                          ? item.styleOption.textDecoration
                          : "left"
                      }
                    },
                    [
                      item
                        ? [
                            item.type === 1
                              ? _c("div", {
                                  staticClass: "editorShowArea ql-editor",
                                  domProps: { innerHTML: _vm._s(item.value) }
                                })
                              : item.type === 3
                              ? _c("questionRender", {
                                  attrs: {
                                    question: item,
                                    isShow: _vm.isShow,
                                    questionAnswer: item.questionAnswer
                                  },
                                  on: {
                                    getQuestionAnswer: function($event) {
                                      return _vm.getQuestionAnswer(
                                        arguments[0],
                                        index
                                      )
                                    },
                                    handleGoStudy: _vm.handleGoStudy
                                  }
                                })
                              : item.type === 5
                              ? _c("div", { staticClass: "lianjie" }, [
                                  _c(
                                    "span",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.openlianjie(item)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  )
                                ])
                              : item.type === 7
                              ? _c("el-image", {
                                  staticClass: "type6resouce",
                                  style: {
                                    width: item.styleOption.width
                                      ? item.styleOption.width + "%"
                                      : "50%"
                                  },
                                  attrs: {
                                    src: item.value,
                                    "preview-src-list": [item.value]
                                  }
                                })
                              : item.type === 10
                              ? [
                                  _c("div", {
                                    ref: "zl_edit_video_line" + index,
                                    refInFor: true,
                                    style: {
                                      height:
                                        _vm.isFixed && _vm.playingIndex == index
                                          ? _vm.videoShowHeight + "px"
                                          : 0
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "video",
                                    {
                                      directives: [
                                        { name: "drag", rawName: "v-drag" }
                                      ],
                                      ref: "zl_edit_video" + index,
                                      refInFor: true,
                                      staticClass: "video-js type6resouce",
                                      class: {
                                        is_fixed:
                                          _vm.isFixed &&
                                          _vm.playingIndex == index,
                                        noneStyle: !_vm.isFixed
                                      },
                                      style: {
                                        width:
                                          _vm.isFixed &&
                                          _vm.playingIndex == index
                                            ? "400px"
                                            : item.styleOption.width + "%"
                                      },
                                      attrs: {
                                        controls: "",
                                        preload: "auto",
                                        controlslist: "nodownload",
                                        "data-setup": "{'example_option':true}"
                                      },
                                      on: {
                                        play: function($event) {
                                          return _vm.videoPlayItem(item, index)
                                        },
                                        ended: _vm.endVideoItem
                                      }
                                    },
                                    [
                                      _c("source", {
                                        staticClass: "video",
                                        attrs: {
                                          src: item.value,
                                          type: "video/mp4"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "vjs-no-js" }, [
                                        _vm._v("不支持播放")
                                      ])
                                    ]
                                  )
                                ]
                              : item.type === 11
                              ? _c("code-compiler", {
                                  ref: "codeCompiler",
                                  refInFor: true,
                                  attrs: {
                                    readPage: true,
                                    readOnly: "",
                                    refresh: item.value
                                  },
                                  model: {
                                    value: item.value,
                                    callback: function($$v) {
                                      _vm.$set(item, "value", $$v)
                                    },
                                    expression: "item.value"
                                  }
                                })
                              : item.type === 12
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "bottom",
                                          trigger: "click"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "zl_button zl_blueButton",
                                            on: {
                                              click: function($event) {
                                                return _vm.handleImport(
                                                  item.value
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("下 载")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              slot: "reference",
                                              size: "mini"
                                            },
                                            slot: "reference"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(item.name || item.value)
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : item.type == 110
                              ? _c("iframe", {
                                  staticStyle: {
                                    width: "100%",
                                    height: "450px"
                                  },
                                  attrs: {
                                    src: _vm.pptIframe + item.value,
                                    frameborder: "0"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.isShow && _vm.currentValue.taskType == 1
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-top": "7px" } },
                                  [
                                    item.type === 11 &&
                                    item.extendOption &&
                                    item.extendOption.operationIsShow
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "zl_button zl_blueButton",
                                            on: {
                                              click: function($event) {
                                                return _vm.handleGoStudy(item)
                                              }
                                            }
                                          },
                                          [_vm._v("试一下\n              ")]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e()
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                }),
                0
              )
            ]
          )
        : _vm.currentValue.szrtType === 7
        ? _c("div", { staticClass: "contentItem" }, [
            _c("img", {
              staticClass: "status_1_content_resouce",
              attrs: { src: _vm.currentValue.newAttaUrl }
            })
          ])
        : _vm.currentValue.szrtType == 9
        ? _c(
            "div",
            { staticStyle: { height: "calc(100% - 42px)", overflow: "auto" } },
            [
              _c("div", {
                staticClass: "editorShowArea ql-editor",
                domProps: { innerHTML: _vm._s(_vm.currentValue.content) }
              })
            ]
          )
        : _vm.currentValue.szrtType == 10
        ? _c("div", { staticClass: "new_course_render_test_wrap" }, [
            _c("div", { staticClass: "new_course_render_test_wrap_header" }, [
              _vm.currentValue.name
                ? _c("span", { staticStyle: { "padding-right": "10px" } }, [
                    _vm._v(_vm._s(_vm.currentValue.name))
                  ])
                : _vm.currentValue.tagName
                ? _c("span", { staticStyle: { "padding-right": "10px" } }, [
                    _vm._v(_vm._s(_vm.currentValue.tagName))
                  ])
                : _vm._e(),
              _vm._v("\n        (测验)包含以下试题：\n      ")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.currentValue.testPaper.sections, function(item, key) {
                return _c("li", { key: key }, [
                  _c("p", { staticClass: "test_wrap_p" }, [
                    _c("span", { staticClass: "test_wrap_span1" }, [
                      _vm._v(_vm._s(item.sectionAlias || item.sectionName))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "test_wrap_span2" }, [
                      _vm._v(
                        _vm._s(item.sectionScore) +
                          "分 · " +
                          _vm._s(item.questionCount) +
                          "题"
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 1
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/dxuan.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 2
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/duoxuan.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 3
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/pdan.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 9
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/shicao.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 5
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/jianda.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 6
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/zuhe.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 4
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/tiankong.png")
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.question[0].questionTypeId == 10
                    ? _c("img", {
                        attrs: {
                          src: require("../../../../static/images/newCourse/fujian.png")
                        }
                      })
                    : _vm._e()
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { height: "20%" } })
          ])
        : _vm.currentValue.szrtType === 11
        ? _c("div", { staticClass: "currentValueName" }, [
            _vm.currentValue.name
              ? _c("span", { staticStyle: { "padding-right": "10px" } }, [
                  _vm._v(_vm._s(_vm.currentValue.name))
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "homeworkContent" }, [
              _c("div", { staticClass: "details_left" }, [
                _c("div", {
                  staticClass: "workMatter editorShowArea ql-editor",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.currentValue.homeworkBaseJSON.homeworkContents[0]
                        .content
                    )
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "details_right" }, [
                _c(
                  "div",
                  { staticStyle: { "padding-top": "30px" } },
                  _vm._l(
                    _vm.currentValue.homeworkBaseJSON.homeworkContents[0]
                      .attachment,
                    function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "fujian_box",
                          attrs: { title: item.attachmentName },
                          on: {
                            mouseover: function($event) {
                              return _vm.mouseover(index)
                            },
                            mouseleave: function($event) {
                              return _vm.mouseleave(index)
                            }
                          }
                        },
                        [
                          _c(
                            "ToolTip",
                            {
                              attrs: {
                                href: item.attachmentUrl,
                                name: item.attachmentName,
                                type: item.type,
                                id: item.id,
                                isShow: item.show,
                                xaizai: false
                              }
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.attachmentName) +
                                  "\n              "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    }
                  ),
                  0
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.videoSrc
        ? _c("video-preview", {
            attrs: { videoSrc: _vm.videoSrc, videoName: _vm.videoName },
            on: { closeFn: _vm.closeVideoPreview }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.imgSrc
        ? _c("imgView", {
            attrs: { imgSrc: _vm.imgSrc, imgName: _vm.imgName },
            on: { closeFn: _vm.closeImgview }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.audioSrc
        ? _c("audioView", {
            ref: "audio",
            attrs: { audioSrc: _vm.audioSrc, audioName: _vm.audioName },
            on: { closeFn: _vm.closeaudioView }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1acd7b79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1acd7b79","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/new_course_editor/components/new_course_render.vue
// module id = null
// module chunks = 